
export const NOTIFICATION = "NOTIFICATION"
export const NOTIFICATION_SUCCESSFUL = "NOTIFICATION_SUCCESSFUL"
export const NOTIFICATION_FAILED = "NOTIFICATION_FAILED"

// update notification
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION"
export const UPDATE_NOTIFICATION_SUCCESSFUL = "UPDATE_NOTIFICATION_SUCCESSFUL"
export const UPDATE_NOTIFICATION_FAILED = "UPDATE_NOTIFICATION_FAILED"